import { useQuery } from '@hooks/reactQuery';

import { getPortalTimelinePriorities } from '@api/portalTimeline';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_TIMELINE_PRIORITIES } from '@constants/queryKeys';

interface IUseQueryPortalTimelinePrioritiesReturned {
	portalTimelinePriorities: Array<TSelectOption>;
	isLoadingPortalTimelinePriorities: boolean;
}

export const useQueryPortalTimelinePriorities = (): IUseQueryPortalTimelinePrioritiesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TIMELINE_PRIORITIES],
		queryFn: getPortalTimelinePriorities,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalTimelinePriorities: data || [],
		isLoadingPortalTimelinePriorities: isLoading || isFetching,
	};
};
